import type { TransactionLookupInput, TransactionsResult } from '@/types';
import { ApiError } from '@/features/bet-inspection/lib/api';

/**
 * POST {api}/transactions — the same transaction(s) across all four stores, by
 * any ONE id. No play_service_id: the backend resolves the operator from the row.
 */
export async function fetchTransactions(params: {
  api: string;
  token: string | null;
  input: TransactionLookupInput;
  signal?: AbortSignal;
}): Promise<TransactionsResult> {
  const base = params.api.replace(/\/+$/, '');

  let res: Response;
  try {
    res = await fetch(`${base}/transactions`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        ...(params.token ? { authorization: `Bearer ${params.token}` } : {}),
      },
      body: JSON.stringify({ input: params.input }),
      signal: params.signal,
    });
  } catch (err) {
    if ((err as Error)?.name === 'AbortError') throw err;
    throw new ApiError(
      `Could not reach the betlens API at ${base}. Check the API base URL, that the ` +
        `backend is running, and that it allows this origin (CORS).`,
      0,
    );
  }

  if (!res.ok) {
    const body = (await res.json().catch(() => null)) as { error?: string } | null;
    throw new ApiError(body?.error ?? `Request failed (${res.status})`, res.status);
  }

  return (await res.json()) as TransactionsResult;
}
